import { AxiosError } from 'axios';
import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const createGuestPayUrl = async () => {
  try {
    const response = await instance({
      url: Endpoints.GET_PAYURL,
      data: {
        email: sessionStorage.getItem('guestEmail'),
        cartCode: sessionStorage.getItem('guestCartId'),
      },
      method: 'POST',
    });
    return response;
  } catch (e) {
    console.log('Unable to clear cart', e);
    return (e as AxiosError).response?.status;
  }
};
